import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './shared/theme/globals.css';
import { applyEntryRedirect } from './shared/auth/entryRedirect';

// Cada ingreso nuevo a LCC empieza en el Menu de aplicaciones (ver entryRedirect.ts).
applyEntryRedirect();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
